/**
 * Logix Offline Branding
 * Read/write org branding to IndexedDB cache store.
 * Apply CSS custom properties when offline.
 */

import { cacheGet } from "./db"

/**
 * Apply org branding from IndexedDB cache.
 * Falls back gracefully if no branding cached.
 */
export async function applyBranding() {
  try {
    const branding = await cacheGet("branding")
    if (!branding) return

    const root = document.documentElement

    if (branding.primary_color) {
      root.style.setProperty("--brand-primary", branding.primary_color)
    }

    // Update page title with org name if available
    if (branding.name) {
      const titleEl = document.querySelector("[data-brand-name]")
      if (titleEl) titleEl.textContent = branding.name
    }
  } catch {
    // Silently fail — branding is non-critical
  }
}

/**
 * Get cached branding data.
 */
export async function getBranding() {
  try {
    return await cacheGet("branding")
  } catch {
    return null
  }
}
